export const RANK_TITLES = {
  1: 'Explorer',
  2: 'Builder',
  3: 'Achiever',
  4: 'Leader',
  5: 'Pro Leader',
  6: 'Elite Leader',
  7: 'Ambassador',
  8: 'Crown Ambassador',
  9: 'Global Ambassador',
  10: 'DynaFi Legend',
};

export function rankCode(rank) {
  const level = Number(rank);
  if (!Number.isFinite(level) || level <= 0) return '';
  return `V${level}`;
}

export function rankTitle(rank) {
  const level = Number(rank);
  if (!Number.isFinite(level) || level <= 0) return 'Rank 0';
  return RANK_TITLES[level] || `Rank ${level}`;
}
